import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

// Importação dos componentes
import Header from './components/Header/Header';
import HeroSection from './components/HeroSection/HeroSection';
import Services from './components/Services/Services';
import Differentials from './components/Differentials/Differentials';
import ESocial from './components/ESocial/ESocial';
import CapacitaSeg from './components/GroupCompanies/CapacitaSeg';
import ExameSeg from './components/GroupCompanies/ExameSeg';
import Trainings from './components/Trainings/Trainings';
import ComplementaryExams from './components/ComplementaryExams/ComplementaryExams';
import About from './components/About/About';
import ContactForm from './components/ContactForm/ContactForm';
import Footer from './components/Footer/Footer';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import InfoModal from './components/InfoModal/InfoModal';

function App() {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const openInfoModal = () => setIsInfoModalOpen(true);
  const closeInfoModal = () => setIsInfoModalOpen(false);

  return (
    <Router>
      <div className="App">
        {/* Cabeçalho */}
        <Header openInfoModal={openInfoModal} />
        
        {/* Seção principal */}
        <main>
          {/* Seção Hero */}
          <HeroSection />
          
          {/* Nossos Serviços */}
          <Services />
          
          {/* Diferenciais */}
          <Differentials />
          
          {/* eSocial */}
          <ESocial />
          
          {/* CapacitaSeg */}
          <CapacitaSeg />
          
          {/* ExameSeg */}
          <ExameSeg />
          
          {/* Treinamentos */}
          <Trainings />
          
          {/* Exames Complementares */}
          <ComplementaryExams />
          
          {/* Sobre a FocoSeg */}
          <About />
          
          {/* Formulário de Contato */}
          <ContactForm />
        </main>
        
        {/* Rodapé */}
        <Footer openInfoModal={openInfoModal} />
        
        {/* Botão flutuante do WhatsApp */}
        <WhatsAppButton />
        
        {/* Modal informativo */}
        <InfoModal isOpen={isInfoModalOpen} onClose={closeInfoModal} />
      </div>
    </Router>
  );
}

export default App;
